/* ============================================================================
   NAMING THIS LATER — SEARCH  (playbook §12.3 · §12.5 · §12.6)

   Loaded from <head> with `defer`, AFTER ntl-common.js, so window.NTL exists.
   Everything here is delegation-based or (re)mounted from NTL.initAll, so it
   survives `shopify:section:load` and drawer re-renders.

   What it owns
   ------------
   1. PREDICTIVE SEARCH on any  <form data-ntl-psearch>  — debounced fetch of
      routes.predictive_search_url (resources[type]=product,article,page),
      a designed results panel it builds itself, full keyboard navigation
      (Up / Down / Enter / Escape / Tab), aria-live status, a loading skeleton
      and an empty state. The panel is progressive: with JS off the form is a
      plain GET to /search and nothing below is needed.
   2. A bridge so the header's search trigger opens OUR drawer
      (#ntl-search-drawer) instead of the theme's stock offcanvas.
   3. `[data-ntl-autosubmit]` — a <select> that submits its own form on change
      (the search page's sort control). Its native submit button is only hidden
      by CSS under `html.js`, so the control still works with JS off.

   The panel's CSS lives in assets/ntl-base.css (§5.5.4: the drawer is rendered
   globally from a snippet, and a snippet cannot hold a stylesheet block).
   ========================================================================= */
(function () {
  'use strict';

  var NTL = window.NTL = window.NTL || {};

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function txt(html) {
    var d = document.createElement('div');
    d.innerHTML = String(html == null ? '' : html);
    return (d.textContent || '').replace(/\s+/g, ' ').trim();
  }
  function clip(s, n) { s = txt(s); return s.length > n ? s.slice(0, n - 1).trim() + '…' : s; }

  /* money — suggest.json returns the amount in cents as a string ("2000"); some
     shops/apps hand back an already-formatted string. Handle both, never print
     a raw integer. */
  function price(v) {
    if (v === null || v === undefined || v === '') return '';
    var s = String(v).trim();
    if (/^-?\d+$/.test(s)) return NTL.money ? NTL.money(parseInt(s, 10)) : s;
    if (/^-?\d+\.\d+$/.test(s)) return NTL.money ? NTL.money(Math.round(parseFloat(s) * 100)) : s;
    return s;
  }

  function thumb(src, w, h) {
    if (!src) return '';
    var u = String(src);
    /* Shopify CDN images accept a width param; keep everything else untouched */
    if (u.indexOf('cdn.shopify.com') > -1 || u.indexOf('/cdn/shop/') > -1) {
      u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w * 2);
    }
    return '<img src="' + esc(u) + '" alt="" width="' + w + '" height="' + h +
           '" loading="lazy" decoding="async">';
  }

  /* ── the panel ────────────────────────────────────────────────────────── */
  var UID = 0;

  function mount(form) {
    if (!form || form.dataset.ntlPsInit) return;
    form.dataset.ntlPsInit = '1';

    var input = form.querySelector('input[type="search"], input[name="q"]');
    if (!input) return;

    var id      = 'ntl-ps-' + (++UID);
    var host    = form.querySelector('[data-ntl-psearch-panel]');
    var ownHost = false;
    if (!host) {
      host = document.createElement('div');
      ownHost = true;
      /* .ntl-sf-in is position:relative, so the dropdown anchors to the FIELD
         ROW rather than to the whole form (which may carry a hint line below) */
      (form.querySelector('.ntl-sf-in') || form).appendChild(host);
    }
    host.className = 'ntl ntl-ps';
    host.id        = id;
    host.hidden    = true;
    if (ownHost) host.setAttribute('data-ntl-psearch-panel', '');

    var live = form.querySelector('[data-ntl-psearch-status]');
    if (!live) {
      live = document.createElement('span');
      live.className = 'ntl-visually-hidden';
      live.setAttribute('data-ntl-psearch-status', '');
      form.appendChild(live);
    }
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', id);
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');

    var d       = form.dataset;
    var root    = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url     = d.ntlPsearchUrl || (root + 'search/suggest');
    var types   = d.ntlPsearchTypes || 'product,article,page';
    var limit   = parseInt(d.ntlPsearchLimit, 10) || 5;
    var minLen  = parseInt(d.ntlPsearchMin, 10) || 2;
    var wait    = parseInt(d.ntlPsearchDebounce, 10) || 200;
    var action  = form.getAttribute('action') || (root + 'search');
    var copy = {
      products: d.ntlPsearchLProducts || 'Products',
      articles: d.ntlPsearchLArticles || 'Journal',
      pages:    d.ntlPsearchLPages    || 'Pages',
      all:      d.ntlPsearchLAll      || 'View all results',
      empty:    d.ntlPsearchLEmpty    || 'No matches yet',
      emptyMsg: d.ntlPsearchLEmptyMsg || 'Try a colour, a material, or a room — “moss”, “alpaca”, “bed”.',
      sold:     d.ntlPsearchLSold     || 'Sold out'
    };

    var cache = {}, timer = null, ctrl = null, open = false, idx = -1, opts = [], lastQ = '';

    function setExpanded(v) {
      open = v;
      host.hidden = !v;
      input.setAttribute('aria-expanded', v ? 'true' : 'false');
      form.classList.toggle('ntl-ps-on', !!v);
      if (!v) { idx = -1; input.removeAttribute('aria-activedescendant'); }
    }

    function collect() {
      opts = $$('.ntl-ps-o', host);
      opts.forEach(function (o, i) { o.id = id + '-o' + i; });
    }

    function highlight(n) {
      if (!opts.length) return;
      if (idx > -1 && opts[idx]) opts[idx].setAttribute('aria-selected', 'false');
      idx = n;
      if (idx < 0) { input.removeAttribute('aria-activedescendant'); return; }
      var el = opts[idx];
      el.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', el.id);
      if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    }

    function skeleton() {
      var rows = '';
      for (var i = 0; i < 4; i++) {
        rows += '<div class="ntl-ps-o is-skel" aria-hidden="true">' +
                  '<span class="ntl-ps-th ntl-skel"></span>' +
                  '<span class="ntl-ps-tx">' +
                    '<span class="ntl-skel" style="width:70%;height:12px"></span>' +
                    '<span class="ntl-skel" style="width:34%;height:11px"></span>' +
                  '</span>' +
                '</div>';
      }
      host.innerHTML = '<div class="ntl-ps-in" aria-busy="true">' +
                         '<p class="ntl-ps-h">' + esc(copy.products) + '</p>' + rows +
                       '</div>';
      collect();
      setExpanded(true);
    }

    function empty(q) {
      host.innerHTML =
        '<div class="ntl-ps-in">' +
          '<div class="ntl-ps-empty">' +
            '<i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>' +
            '<b>' + esc(copy.empty) + '</b>' +
            '<p>' + esc(copy.emptyMsg) + '</p>' +
            '<a class="ntl-ps-o ntl-ps-all" href="' + esc(action) + '?q=' + encodeURIComponent(q) +
              '&amp;type=' + esc(types.split(',').join(',')) + '" role="option" aria-selected="false">' +
              '<span>' + esc(copy.all) + ' “' + esc(q) + '”</span>' +
              '<i class="fa-solid fa-arrow-right" aria-hidden="true"></i></a>' +
          '</div>' +
        '</div>';
      collect();
      setExpanded(true);
      live.textContent = copy.empty;
    }

    function group(title, rows) {
      if (!rows) return '';
      return '<p class="ntl-ps-h">' + esc(title) + '</p>' + rows;
    }

    function render(data, q) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [], articles = r.articles || [], pages = r.pages || [];
      var total = products.length + articles.length + pages.length;
      if (!total) { empty(q); return; }

      var pr = '';
      products.forEach(function (p) {
        var sub = p.available === false ? copy.sold : (p.product_type || p.vendor || '');
        pr += '<a class="ntl-ps-o" role="option" aria-selected="false" tabindex="-1" href="' + esc(p.url) + '">' +
                '<span class="ntl-ps-th">' + (thumb(p.image || p.featured_image, 48, 60) ||
                  '<span class="ntl-ps-th-e" aria-hidden="true"></span>') + '</span>' +
                '<span class="ntl-ps-tx">' +
                  '<b>' + esc(txt(p.title)) + '</b>' +
                  (sub ? '<span class="ntl-ps-sub">' + esc(sub) + '</span>' : '') +
                '</span>' +
                '<span class="ntl-ps-p">' + esc(price(p.price)) + '</span>' +
              '</a>';
      });

      var ar = '';
      articles.forEach(function (a) {
        ar += '<a class="ntl-ps-o" role="option" aria-selected="false" tabindex="-1" href="' + esc(a.url) + '">' +
                '<span class="ntl-ps-th is-sq">' + (thumb(a.image, 48, 48) ||
                  '<span class="ntl-ps-th-e" aria-hidden="true"><i class="fa-solid fa-feather"></i></span>') + '</span>' +
                '<span class="ntl-ps-tx">' +
                  '<b>' + esc(txt(a.title)) + '</b>' +
                  (a.summary_html ? '<span class="ntl-ps-sub">' + esc(clip(a.summary_html, 62)) + '</span>' : '') +
                '</span>' +
              '</a>';
      });

      var pg = '';
      pages.forEach(function (p) {
        pg += '<a class="ntl-ps-o is-plain" role="option" aria-selected="false" tabindex="-1" href="' + esc(p.url) + '">' +
                '<span class="ntl-ps-ic" aria-hidden="true"><i class="fa-solid fa-link"></i></span>' +
                '<span class="ntl-ps-tx"><b>' + esc(txt(p.title)) + '</b></span>' +
              '</a>';
      });

      host.innerHTML =
        '<div class="ntl-ps-in" role="listbox" aria-label="' + esc(copy.all) + '">' +
          group(copy.products, pr) + group(copy.articles, ar) + group(copy.pages, pg) +
          '<a class="ntl-ps-o ntl-ps-all" role="option" aria-selected="false" tabindex="-1" href="' +
            esc(action) + '?q=' + encodeURIComponent(q) + '&amp;type=' + esc(types) + '">' +
            '<span>' + esc(copy.all) + ' “' + esc(q) + '”</span>' +
            '<i class="fa-solid fa-arrow-right" aria-hidden="true"></i></a>' +
        '</div>';
      collect();
      setExpanded(true);
      live.textContent = total + (total === 1 ? ' result' : ' results') + ' for ' + q;
    }

    function query(q) {
      if (cache[q]) { render(cache[q], q); return; }
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      skeleton();
      var u = url + (url.indexOf('.json') > -1 ? '' : '.json') +
              '?q=' + encodeURIComponent(q) +
              '&resources[type]=' + encodeURIComponent(types) +
              '&resources[limit]=' + limit +
              '&resources[options][unavailable_products]=last';
      fetch(u, { signal: ctrl ? ctrl.signal : undefined, headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.json();
        })
        .then(function (data) {
          cache[q] = data;
          if (input.value.trim() === q) render(data, q);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          setExpanded(false);
          live.textContent = '';
        });
    }

    function run() {
      var q = input.value.trim();
      if (q === lastQ) return;
      lastQ = q;
      if (q.length < minLen) { setExpanded(false); live.textContent = ''; return; }
      query(q);
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(run, wait);
    });
    input.addEventListener('focus', function () {
      if (!open && input.value.trim().length >= minLen) { lastQ = ''; run(); }
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (open) { setExpanded(false); e.stopPropagation(); }
        else if (input.value) { input.value = ''; lastQ = ''; }
        return;
      }
      if (!open || !opts.length) {
        if (e.key === 'ArrowDown' && input.value.trim().length >= minLen) { lastQ = ''; run(); }
        return;
      }
      if (e.key === 'ArrowDown')      { e.preventDefault(); highlight((idx + 1) % opts.length); }
      else if (e.key === 'ArrowUp')   { e.preventDefault(); highlight(idx <= 0 ? opts.length - 1 : idx - 1); }
      else if (e.key === 'Home')      { e.preventDefault(); highlight(0); }
      else if (e.key === 'End')       { e.preventDefault(); highlight(opts.length - 1); }
      else if (e.key === 'Tab')       { setExpanded(false); }
      else if (e.key === 'Enter') {
        if (idx > -1 && opts[idx] && opts[idx].href) { e.preventDefault(); window.location.href = opts[idx].href; }
      }
    });

    host.addEventListener('mousemove', function (e) {
      var o = e.target.closest ? e.target.closest('.ntl-ps-o') : null;
      if (!o || o.classList.contains('is-skel')) return;
      var i = opts.indexOf(o);
      if (i > -1 && i !== idx) highlight(i);
    });

    form.addEventListener('focusout', function (e) {
      setTimeout(function () {
        if (!form.contains(document.activeElement)) setExpanded(false);
      }, 0);
    });

    document.addEventListener('click', function (e) {
      if (open && !form.contains(e.target)) setExpanded(false);
    });
  }

  function mountAll() { $$('form[data-ntl-psearch]').forEach(mount); }

  /* ── the header trigger opens OUR drawer, never the theme's offcanvas ──── */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest
      ? e.target.closest('[data-ntl-search-open],[data-bs-target="#offcanvas-search"],a[href="#offcanvas-search"]')
      : null;
    if (!t) return;
    var panel = $('#ntl-search-drawer');
    if (!panel || !NTL.openPanel) return;   /* no drawer → let the link go to /search */
    e.preventDefault();
    e.stopPropagation();
    NTL.openPanel(panel);
    var i = panel.querySelector('input[type="search"]');
    if (i) setTimeout(function () { try { i.focus(); } catch (err) {} }, 80);
  }, true);

  /* ── a <select> that submits its own form (search sort) ───────────────── */
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('[data-ntl-autosubmit]') : null;
    if (!sel || !sel.form) return;
    if (sel.form.requestSubmit) sel.form.requestSubmit();
    else sel.form.submit();
  });

  /* ── boot + re-boot on every section load (§5.6: guard every init) ────── */
  function boot() { try { mountAll(); } catch (err) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  NTL.mountPredictiveSearch = mountAll;
})();
